import React from "react";

import Select from "react-select";

import { Button, ButtonGroup, Dropdown } from "aible";

import CapSlider from "components/Project/CapSlider";

import { FRONTIER_SLIDERS_VIEW } from "containers/FrontierSliders/FrontierSliders";

import Toggle from "react-toggle";

import styles from "./style.module.css";

export default class RunFrontier extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { isFeedback: this.props.isFeedback || false };
  }

  render() {
    const {
      userThresholds,
      isOverallSegment,
      isMonitoring,
      capModels,
      capValue,
      activeSegment,
      userId,
      isFeedback,
      hideButton,
      isNext,
      value,
      onChange,
      valueOverride
    } = this.props;

    const retIsFeedback = isFeedback !== undefined ? isFeedback : this.state.isFeedback;

    let retModels = {};

    let activeSegmentUserSelection = undefined;
    let activeSegmentFeedback =
      activeSegment &&
      activeSegment.roles &&
      activeSegment.roles.length > 0 &&
      activeSegment.roles[0].preferences &&
      activeSegment.roles[0].preferences.feedback;

    if (userId) {
      const userRole =
        activeSegment.roles &&
        activeSegment.roles.length > 0 &&
        activeSegment.roles.find((elem) => {
          return elem && elem.role_user && Number(elem.role_user.id) === Number(userId);
        });

      if (userRole && userRole.preferences && userRole.preferences.feedback) {
        activeSegmentFeedback = userRole.preferences.feedback;
      } else {
        activeSegmentFeedback = {};
      }

      if (
        userRole &&
        userRole.preferences &&
        (userRole.preferences.percent_processed === 0 || Boolean(userRole.preferences.percent_processed))
      ) {
        const rawUserSelection = userRole.preferences.percent_processed;
        activeSegmentUserSelection = Math.max(0, Math.min(100, Number(rawUserSelection) * 100));
      }
    }

    Object.keys(capModels).forEach((c) => {
      if (retIsFeedback != true) {
        retModels[c] = { model_data: capModels[c] };
      } else {
        const retFeedback =
          activeSegmentFeedback && activeSegmentFeedback[capModels[c].id]
            ? activeSegmentFeedback[capModels[c].id]
            : undefined;

        let modelColor = "#E6E6FC";
        if (retFeedback) {
          modelColor = retFeedback > 0 ? "#5BCF74" : "#F8CD7E";
        }

        retModels[c] = {
          model_data: capModels[c],
          color: modelColor
        };
      }
    });

    let retCapValue = capValue;
    if (retIsFeedback && activeSegmentUserSelection !== undefined) {
      retCapValue = activeSegmentUserSelection;
    }
    if ((valueOverride || isNext) && value !== undefined) {
      retCapValue = value;
    }

    return (
      <div className={styles.runFrontier}>
        <div className={styles.fButton}>
          {!hideButton && (
            <Button
              onClick={() => this.setState({ isFeedback: !retIsFeedback })}
              active={retIsFeedback}
              style={{ padding: "2px" }}
            >
              {"Feedback"}
            </Button>
          )}
        </div>
        <CapSlider
          capModels={retModels}
          isMonitoring={isMonitoring}
          isOverallSegment={isOverallSegment}
          userThresholds={userThresholds}
          currentImpact={retCapValue}
          isWizard
          isNext
          onChange={isNext ? onChange : undefined}
        />
      </div>
    );
  }
}
